// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__tqTpx","leftSide":"PageHeader_leftSide__cnwwA","rightSide":"PageHeader_rightSide__QvcHZ","spaceBetween":"PageHeader_spaceBetween__7eHbu"};